/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, computed, observable } from 'mobx';
import { LuisId } from 'src/luis/types/Resource';
import { EntityRoleStore } from 'src/luis/types/stores/entities/EntityRoleStore';
import { EntityStore } from 'src/luis/types/stores/entities/EntityStore';

export type BrushAttachedData = {
    normalizedValue: string;
    entity: EntityStore;
    parentEntity?: EntityStore;
    role?: EntityRoleStore;
};

/**
 * Reactive store encapsulate all the brush labeling UI states.
 */
export class BrushStore {
    @observable
    public currentUtteranceId: LuisId;

    @observable
    public hoveredEntitiesIds: string[];

    @observable
    private isValidState: boolean;

    constructor() {
        this.currentUtteranceId = null;
        this.hoveredEntitiesIds = [];
        this.isValidState = false;
    }

    /**
     * Setter for the current utterance id.
     */
    @action
    public setCurrentUtteranceId(uid: LuisId) {
        this.currentUtteranceId = uid;
    }

    /**
     * Setter for the hovered entities ids.
     */
    @action
    public setHoveredEntitiesIds(entitiesIds: string[]) {
        this.hoveredEntitiesIds = entitiesIds;
    }

    /**
     * Setter for the isValidState property.
     */
    @action
    public setIsValidState(isValid: boolean) {
        this.isValidState = isValid;
    }

    @computed
    public get invalidUtteranceId() {
        return this.isValidState ? null : this.currentUtteranceId;
    }
}
